import React from 'react';
import { Row, Col } from 'antd';
import InfoCardSkeleton from '../InfoCard/InfoCardSkeleton';
import { GridType } from '../../types';

const InfoCardListSkeleton: React.FC<GridType> = ({ row, col }) => {
  return (
    <Row {...row}>
      {Array(12)
        .fill(undefined)
        .map((item, index) => (
          <Col {...col} key={index}>
            <InfoCardSkeleton />
          </Col>
        ))}
    </Row>
  );
};

export default InfoCardListSkeleton;
